import { motion } from "framer-motion";
import { ButtonClose, ButtonPopup } from "../ui";
import { useNavigate } from "react-router-dom";

const AvisoLegal: React.FC = () => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div
      className="w-full h-screen flex items-center justify-center px-4 py-10 bg-cover bg-center relative"
      style={{ backgroundImage: "url('/img/politicas/fondoLinkservs.png')" }}
    >
      {/* 🔹 Overlay oscuro */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

      <motion.div
        className="relative z-10 w-[210mm] max-w-full max-h-[95vh] rounded-2xl border border-white/20 shadow-2xl bg-black/30 backdrop-blur-xs overflow-hidden"
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* 🔹 Contenido scrollable */}
        <div className="p-8 overflow-y-auto max-h-[95vh] text-white">
          {/* Botón de cierre */}
          <div className="flex justify-end mb-6">
            <ButtonClose onClick={handleClose} />
          </div>

          {/* Título */}
          <h1 className="text-4xl font-extrabold text-center mb-10 text-white">
            Aviso Legal
          </h1>

          {/* Contenido */}
          <div className="space-y-8 leading-relaxed text-justify text-white/80">
            {/* 1. Identificación */}
            <section>
              <p className="mb-4">
                En cumplimiento de lo dispuesto en el artículo 10 de la Ley
                34/2002, de 11 de julio, de Servicios de la Sociedad de la
                Información y Comercio Electrónico (LSSICE), se informa que el
                dominio{" "}
                <a
                  href="https://www.linkservs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  www.linkservs.com
                </a>{" "}
                es propiedad de <strong>CuadraNex S.L.</strong>, sociedad
                española con domicilio en{" "}
                <strong>c/ Oropesa nº 11, Yuncos (Toledo), España</strong>,
                inscrita en el Registro Mercantil de Toledo, Tomo xxxx, Folio
                xx, Hoja TO xxxxxx, Inscripción 1ª — CIF:{" "}
                <strong>B-26925339</strong>.
              </p>
              <p>
                Puede contactarnos por correo postal, telefónicamente al{" "}
                <span className="font-semibold">925 18 11 36</span> o a través
                del correo{" "}
                <a
                  href="mailto:info@linkservs.com"
                  className="text-blue-600 hover:underline"
                >
                  cuadranex@cuadranex.com
                </a>
              </p>
            </section>

            {/* 2. Usuarios */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                1. Usuarios y Uso de la Plataforma
              </h2>
              <p className="mb-3">
                El acceso y/o uso de la Plataforma atribuye la condición de
                Usuario, implicando la aceptación plena y sin reservas de las
                disposiciones incluidas en el presente Aviso Legal.
              </p>
              <p className="mb-3">
                La Plataforma puede ofrecer acceso a diversos contenidos,
                recursos o servicios propiedad de LinkServs o de terceros. El
                Usuario asume la responsabilidad de su uso, incluyendo el
                registro que pueda ser necesario para acceder a determinados
                servicios o contenidos.
              </p>
            </section>

            {/* 3. Contenido generado mediante Inteligencia Artificial */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                3. Contenido generado mediante Inteligencia Artificial
              </h2>

              <p className="mb-3">
                Parte de las imágenes, ilustraciones, iconos, fondos gráficos y
                otros elementos visuales utilizados en la plataforma LinkServs
                han sido creados o asistidos mediante herramientas de
                Inteligencia Artificial (IA) y posteriormente revisados,
                editados y adaptados por CuadraNex S.L.
              </p>

              <p className="mb-3">
                Todos estos contenidos forman parte de la identidad visual de la
                plataforma y se encuentran protegidos por la normativa vigente
                sobre propiedad intelectual e industrial, quedando prohibida su
                reproducción, distribución, transformación, comunicación pública
                o utilización sin la autorización expresa de CuadraNex S.L.,
                salvo en los casos permitidos por la legislación aplicable.
              </p>

              <p>
                La utilización de herramientas de Inteligencia Artificial para
                la creación de determinados recursos gráficos no implica la
                renuncia a los derechos de uso, explotación o protección que
                correspondan sobre dichos contenidos.
              </p>
            </section>

            {/* 4. Propiedad Intelectual */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                2. Propiedad Intelectual e Industrial
              </h2>
              <p>
                El dominio{" "}
                <a
                  href="https://www.linkservs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  www.linkservs.com
                </a>{" "}
                y todos los derechos de Propiedad Intelectual e Industrial sobre
                el sitio web, su diseño, estructura, código fuente, así como los
                contenidos y elementos que incluye, son titularidad de LinkServs
                S.L. o cuentan con la debida autorización de sus propietarios.
              </p>
            </section>

            {/* 5. Responsabilidad */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                3. Responsabilidad y Garantías
              </h2>
              <p className="mb-3">
                CuadraNex S.L. declara haber adoptado las medidas necesarias,
                dentro de sus posibilidades y del estado actual de la
                tecnología, para garantizar el correcto funcionamiento del sitio
                web y la ausencia de virus o componentes dañinos.
              </p>
              <p>
                No obstante, no se responsabiliza de:
                <ul className="list-disc ml-6 mt-2 space-y-1">
                  <li>
                    La continuidad o disponibilidad de los contenidos y
                    servicios.
                  </li>
                  <li>
                    La inexistencia de errores o defectos en dichos contenidos.
                  </li>
                  <li>
                    La presencia de virus o elementos dañinos en el sitio web.
                  </li>
                  <li>
                    Los daños ocasionados por vulneraciones de seguridad
                    llevadas a cabo por terceros.
                  </li>
                </ul>
              </p>
            </section>

            {/* 6. Modificaciones */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                4. Duración y Modificación
              </h2>
              <p>
                Las condiciones del presente Aviso Legal estarán vigentes hasta
                que sean modificadas. CuadraNex S.L. podrá realizar cambios en
                cualquier momento, que serán comunicados adecuadamente al
                Usuario.
              </p>
            </section>

            {/* 7. Legislación */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                5. Legislación Aplicable
              </h2>
              <p>
                El presente Aviso Legal se regirá e interpretará de acuerdo con
                la legislación española. Para la resolución de conflictos, las
                partes se someten a los Juzgados y Tribunales competentes del
                domicilio del usuario o del lugar del cumplimiento de la
                obligación.
              </p>
            </section>

            {/* 8. Resolución de Litigios */}
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-zinc-800">
                6. Resolución de Litigios en Línea
              </h2>
              <p>
                Conforme al artículo 14.1 del Reglamento (UE) 524/2013, la
                Comisión Europea facilita una plataforma de resolución de
                litigios en línea disponible en:{" "}
                <a
                  href="http://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Comisión Europea
                </a>
                .
              </p>
            </section>
          </div>

          {/* Botón inferior */}
          <div className="flex justify-center mt-10">
            <ButtonPopup onClick={handleClose}>Cerrar</ButtonPopup>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AvisoLegal;
